import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { t } from 'translate/store';
import SystemItem from '../systemItem';

const defaultValue = [
  {
    label: t('Check in thủ công'),
    key: 'manualCheckin',
    value: false,
  },
  {
    label: t('QR code'),
    key: 'qrCode',
    value: false,
  },
  {
    label: t('Đa ngôn ngữ'),
    key: 'adminMultiLanguage',
    value: false,
  },
];

export default function AdminSystem() {
  const [list, setList] = useState(defaultValue);
  const info = useSelector((state) => state.admin.configSystem.info);
  const { t } = useTranslation();
  useEffect(() => {
    if (info) {
      let newList = [...list];
      let keys = Object.keys(info);
      for (let i = 0; i < newList.length; i++) {
        if (keys.includes(newList[i].key)) {
          newList[i].value = info[newList[i].key];
        }
      }
      setList(newList);
    }
  }, [info]);
  return (
    <>
      <h4 className="category">{t('Hệ thống Admin')}</h4>
      <div className="system-list">
        {list.map((item, index) => {
          return (
            <SystemItem
              key={index}
              name={item.label}
              keyName={item.key}
              status={item.value}
            />
          );
        })}
      </div>
    </>
  );
}
